import OrderSummary from '@fd/frontend/components/PurchasePage/OrderSummary/OrderSummary';
import OrderSummaryFooter from '@fd/frontend/components/PurchasePage/OrderSummary/OrderSummaryFooter';
import Page from '@fd/frontend/components/ui/Page';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/Breadcrumb';
import { MobileView } from '@/components/responsive';
import useMobile from '@/hooks/useMobile';
import { NavLink, useNavigate } from 'react-router';
import Flex from '@fd/frontend/components/ui/Flex';
import { LucideArrowLeft } from 'lucide-react';

export default function OrderSummaryPage() {
  const isMobile = useMobile();
  const navigate = useNavigate();

  if (!isMobile) {
    navigate('/proxies/buy');
  }

  return (
    <Page.Container>
      <Page.Heading>
        <BreadcrumbHeading />
        <NavLink to="/proxies/buy">
          <Flex.Row className="gap-2 items-center">
            <LucideArrowLeft className="h-full" />
            <h1>Order summary</h1>
          </Flex.Row>
        </NavLink>
      </Page.Heading>
      <Page.Body>
        <OrderSummary />
        <MobileView>
          <OrderSummaryFooter />
        </MobileView>
      </Page.Body>
    </Page.Container>
  );
}

function BreadcrumbHeading() {
  return (
    <Breadcrumb className="mb-2">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink href="/">Dashboard</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink href="/proxies/buy">Choose plan</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink>Order summary</BreadcrumbLink>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
